<template>
  <div
    class="book-swipe-guide"
    :class="{
      'book-swipe-guide--mobile': !props.isPC,
      'book-swipe-guide--embedded': props.embedded
    }"
    role="status"
    aria-live="polite"
  >
    <img
      class="book-swipe-guide__gesture"
      :src="props.isPC ? desktopGestureIcon : mobileGestureIcon"
      alt=""
      aria-hidden="true"
      draggable="false"
    />
    <span class="book-swipe-guide__copy">
      {{ props.isPC ? '向左滑动鼠标翻页' : '左右滑动翻页' }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import desktopGestureIcon from '@/assets/images/book-swipe-guide-desktop.svg';
  import mobileGestureIcon from '@/assets/images/book-swipe-guide-mobile.svg';

  const props = defineProps<{
    isPC: boolean;
    embedded?: boolean;
  }>();
</script>

<style scoped>
  .book-swipe-guide {
    position: fixed;
    top: 50.6%;
    left: 51.8%;
    z-index: 1101;
    width: 171px;
    height: 144px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 24px 32px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 24px;
    pointer-events: none;
    transform: translate(-50%, -50%);
    animation: book-swipe-guide-lifecycle 2s linear forwards;
  }

  .book-swipe-guide__gesture {
    width: 96px;
    height: 64px;
    display: block;
    flex: 0 0 auto;
  }

  .book-swipe-guide__copy {
    font-family: 'Source Han Sans CN VF', 'Noto Sans SC', 'Microsoft YaHei', sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 19.5px;
    letter-spacing: 0.325px;
    white-space: nowrap;
  }

  .book-swipe-guide--mobile {
    top: 52.5%;
    left: 55%;
    width: 162px;
    height: 135px;
    gap: 4px;
  }

  .book-swipe-guide--mobile .book-swipe-guide__gesture {
    width: 60px;
    height: 60px;
  }

  .book-swipe-guide--mobile .book-swipe-guide__copy {
    font-family: Inter, sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 22.5px;
    letter-spacing: 1.5px;
  }

  .book-swipe-guide--embedded {
    position: absolute;
    top: 50%;
    left: 50%;
  }

  @keyframes book-swipe-guide-lifecycle {
    0%,
    75% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .book-swipe-guide {
      animation: none;
    }
  }
</style>
